/**
 * Punto de entrada de la SPA de Viva Training Club.
 * Una sola aplicación para portal admin, portal profesores y tablet kiosko
 * (Arquitectura §3.2).
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Providers } from "./app/providers.js";
import { router } from "./app/routes.js";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("Falta el div #root en index.html");

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
